﻿window.cObjetSondageMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetTableUpdateLib = function () { return ["sondage"] }

    this.mGetLibBase = function () { return "Sondage"; }
    this.mGetAttributBase = function () { return "le" }
    this.mGetNewLib = function () { return "Nouveau sondage"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') { txt = ((objet.data.nom) ? objet.data.nom : "(aucun nom pour le sondage)") }
        else {
            txt = "sondage"
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        if (typeof dataTemplate == 'undefined') { return $("<i class='fas fa-clipboard-question' title='Sondage'></i>"); }
        else {
            var $Icone = $("<i class='fas fa-clipboard-question' style='position:relative'></i>");
            if (dataTemplate.fini == "1") {
                $("<i class='fas fa-paper-plane dx-theme-accent-as-text-color' style='position:absolute;bottom:-2px;right:-2px;font-size:60%;'></i>").appendTo($Icone)
                $Icone.attr("title", "Sondage terminée")
            } else {
                $("<i class='fas fa-pen dx-theme-accent-as-text-color' style='position:absolute;bottom:-2px;right:-2px;font-size:60%;'></i>").appendTo($Icone)
                $Icone.attr("title", "Sondage en cours")
            }
            return $Icone
        }
    }


    this.mGetItemTemplateHeight = function (type) {
        return 55
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();

    }

    this.mGetNomFromTemplate = function (dataTemplate) {
        return dataTemplate.nom
    }
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        if (dataTemplate.fini == "1") { contentElement.parent().addClass("texture_import_disable_projet_pipeline") }
        else { contentElement.parent().removeClass("texture_import_disable_projet_pipeline") }

        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)

        var $TdNom = $("<td style='width:100%;text-overflow:ellipsis;overflow:hidden;'></td>").appendTo($Tr)
        var $Span = $("<span style='font-weight:bold;'>" + (dataTemplate.nbre_reponse == null ? "0" : dataTemplate.nbre_reponse + "") + " <i class='fas fa-reply'></i></span>").appendTo($TdNom)
        $Span.attr("title", (dataTemplate.nbre_reponse == null ? "aucune réponse" : dataTemplate.nbre_reponse + " réponse" + (dataTemplate.nbre_reponse > 1 ? "s" : "")) + " au sondage")
        $("<span> &bull; </span>").appendTo($TdNom)
        var $Span = $("<span style='font-weight:bold;'>" + (dataTemplate.taux_satisfaction == null || dataTemplate.taux_satisfaction == 0 ? "---" : dataTemplate.taux_satisfaction + "%") + "</span>").appendTo($TdNom)
        $Span.attr("title", (dataTemplate.taux_satisfaction == null || dataTemplate.taux_satisfaction == 0 ? "aucun taux de satisfaction" : dataTemplate.taux_satisfaction + "% de taux de satisfaction"))
        if (dataTemplate.taux_satisfaction == null || dataTemplate.taux_satisfaction == 0) {
            $("<span> <i class='fas fa-face-meh-blank' style='color:gray'></i></span>").appendTo($TdNom)
        } else if (dataTemplate.taux_satisfaction <= 50) {
            $("<span> <i class='fas fa-face-sad-tear' style='color:red'></i></span>").appendTo($TdNom)
        } else if (dataTemplate.taux_satisfaction <= 80) {
            $("<span> <i class='fas fa-face-meh' style='color:orange'></i></span>").appendTo($TdNom)
        } else if (dataTemplate.taux_satisfaction <= 90) {
            $("<span> <i class='fas fa-face-meh' style='color:green'></i></span>").appendTo($TdNom)
        } else {
            $("<span> <i class='fas fa-face-grin-wide' style='color:green'></i></span>").appendTo($TdNom)
        }
        $("<span> &bull; </span>").appendTo($TdNom)
        var $Span = $("<span>" + ((dataTemplate.nom == null) ? "(aucun nom de sondage)" : dataTemplate.nom) + "</span>").appendTo($TdNom)
        $Span.attr("title", ((dataTemplate.nom == null) ? "(aucun nom de sondage)" : dataTemplate.nom))

        var $DivUrl = $("<div style='width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;opacity:0.5;font-size:14px;'/>").appendTo(contentElement)
        var url = this.mGetUrlLinkWithDataTemplate(dataTemplate)
        var $SpanLink = $("<span class='state-hover dx-theme-accent-as-text-color' style='font-size:100%;opacity:1;padding-right:5px;'></span>").appendTo($DivUrl)
        $SpanLink.attr("title", "Cliquer pour copier l'adresse dans le presse-papier")
        $SpanLink.html("<i class='fas fa-copy'></i>")
        $SpanLink.on("click", function (e) {
            e.stopPropagation()
            var $temp = $("<input>");
            $("body").append($temp);
            $temp.val(url).select();
            document.execCommand("copy");
            $temp.remove();
            mNotify("L'adresse du sondage a été copiée dans le presse-papier", "success", 6000)
        })
        var $a = $("<a href='javascript:void(0)' style='font-family:barlow condensed;'>" + url + "</a>").appendTo($DivUrl)
        $a.attr("title", url + "<br/>Partagez ce lien pour donner l'accès à votre sondage.")
        if (this.isDirectory) {
            $a.on("click", function (e) {
                e.stopPropagation()
                window.open(url, "_blank")
            })
        }


        //var $TdNom = $("<td style='width:50%;text-overflow:ellipsis;overflow:hidden;font-weight:bold;'>" + ((dataTemplate.nom == null) ? "" : dataTemplate.nom) + "</td>").appendTo($Tr)
        //var $TdNom = $("<td style='width:25%;text-overflow:ellipsis;overflow:hidden;'>Satisfaction: <span style='font-weight:bold;'>" + (dataTemplate.taux_satisfaction == null ? "(aucun)" : dataTemplate.taux_satisfaction + "%") + "</span></td>").appendTo($Tr)
        //var $TdNom = $("<td style='width:25%;text-overflow:ellipsis;overflow:hidden;'>Nb rep.: <span style='font-weight:bold;'>" + (dataTemplate.nbre_reponse == null ? "(aucune)" : dataTemplate.nbre_reponse + "") + "</span></td>").appendTo($Tr)

    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus, option) {
        if (dataPlus.dcr.toDateIlya(true) == dataPlus.dmo.toDateIlya(true)) {
            $("<span style='' title='Créé le " + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
        } else {
            $("<span style='' title='Créé le " + dataPlus.dcr.toFrenchDateTime() + "<br/>Modifié le " + dataPlus.dmo.toFrenchDateTime() + "'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "<br/><i class='fas fa-pen dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dmo.toDateIlya(true) + "</span>").appendTo(contentElement)
        }
    }

    this.mShowNewSondage = function (optionPopup) {
        var obj = Me.objet.bddRef.getObjet(Me.objet.bddRef.getObjet("sondage").mGetNewData())
        obj.data.id_utilisateur = Me.objet.bddRef.utiCourant.id_utilisateur
        obj.mSave(function () { obj.mShowPopup() })
    }

    this.isPopupFullScreen = false
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    option.fullScreen = true
    //    page.mAddPopup(objet.data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        var dxCtrl = $("<div style='height:100%;width:100%;'/>").appendTo(contentElement).dxCtrlContentSondage({
            bddCtrl: objet.bddRef,
            dataSondage: objet.data,
            optionPopup: option
        }).dxCtrlContentSondage("instance")
    }

    this.mGetWidthPopup = function () { return 700 }
    this.mGetFullScreenPopup = function () { return false }

    this.mGetPopupPositionWidthHeight = function () {
        return {
            width: "calc(100% - 60px)",
            maxWidth: "calc(100% - 60px)",
            height: "calc(100% - 90px)",
            maxHeight: "calc(100% - 50px)",
            position: {
                my: "right top",
                at: "right top",
                of: "body",
                offset: { x: -30, y: 65 }
            }
        }
    }

    this.mGetLookUpForFilterBuilder = function () {
        return {
            dataSource: objet.bddRef.mGetArray("sondage"),
            searchEnabled: true,
            searchExpr: "nom",
            displayExpr: "nom",
            valueExpr: "id_sondage",
            placeholder: "Sélectionnez des sondages"
        }
    }

    this.mGetUrlLink = function () {
        //https://xxxxx.xxxxxx.eu/nom_base/id_sondage/id_table_dest/id_dest/id_sondage_reponse/idxpage/ignore/sondage
        var url = parametre.url_appli.replace("app.", "appgo.") + "/" + objet.bddRef.nom_base + "/" + objet.data.id_sondage + "/xXidtabdestXx/xXiddestXx/0/0/0/sondage"
        return url
    }

    this.mGetUrlLinkWithDataTemplate = function (dataTemplate) {
        //https://xxxxx.xxxxxx.eu/nom_base/id_sondage/id_table_dest/id_dest/id_sondage_reponse/idxpage/ignore/sondage
        var url = parametre.url_appli.replace("app.", "appgo.") + "/" + objet.bddRef.nom_base + "/" + dataTemplate.id_sondage + "/xXidtabdestXx/xXiddestXx/0/0/0/sondage"
        return url
    }

    this.mGetUrlLinkPrint = function (idSondageReponse = null, justeFinalise, dateDebut, dateFin) {
        //https://xxxxx.xxxxxx.eu/nom_base/id_sondage_reponse/sondageprint
        var url = parametre.url_appli.replace("app.", "appgo.") + "/" + objet.bddRef.nom_base + "/" + objet.data.id_sondage + "/" + (idSondageReponse ? idSondageReponse : "0") + "/" + (justeFinalise ? "1" : "0") + "/" + dateDebut.toDDMMAAAA().remplacerTout("/", "") + "/" + dateFin.toDDMMAAAA().remplacerTout("/", "") + "/sondageprint"
        return url
    }

}